import React, { useState } from 'react';
import moment from 'moment';
import cx from 'classnames';
import get from 'lodash/get';
import { PageContainer, ImportsForm } from '@/smart-components';
import { PageContent } from 'components';
import { userIsAuthenticatedRedir } from 'hocs/auth';
import { Typography, Table, Tag, Button, notification } from '@/elements';
import { wsClient } from 'index';
import { getImageData } from 'utils/helpers';

import './index.scss';

const { Title } = Typography;

const ImportsContainer = () => {
  const [submiting, setSubmiting] = useState(false);
  const [results, setResults] = useState([]);
  const [firstFormValues, setFirstFormValues] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleSubmit = (values) => {
    setSubmiting(true);

    const fileReader = new FileReader();

    if (fileReader && values.file && values.file.file) {
        fileReader.readAsArrayBuffer(values.file.file);
        fileReader.onload = async () => {
          const requestPayload = {
            "messageType": "attendance.import.upload-moodle-file",
            "payload": {
              "scheduleId": values.scheduleId,
              "fileStream": getImageData(fileReader.result),
            }
          }
      
          const response = await wsClient.request(requestPayload);
          const messageType = get(response, 'messageType', '');
          const errorMessage = get(response, 'payload.message', 'Ooops! Something went wrong with the file.');

          setSubmiting(false);

          if(messageType === 'core.error.invalid-parameter-format') {
            return notification.error({
              message: 'Error',
              description: errorMessage,
              placement: 'bottomLeft',
            });
          }

          if(messageType === 'core.error.not-found') {
            return notification.error({
              message: 'Error',
              description: errorMessage,
              placement: 'bottomLeft',
            });
          }

          if(
            messageType === 'attendance.import.upload-moodle-file-result' &&
            response.payload &&
            Array.isArray(response.payload) &&
            response.payload.length > 0
          ) {
            const initialSelectedKeys = response.payload
              .filter(result => !Boolean(result.error))
              .map(result => result.studentId);

            setResults(response.payload);
            setFirstFormValues(values);
            setSelectedRowKeys(initialSelectedKeys);
            return setSubmiting(false);
          }

          return notification.error({
            message: 'Error',
            description: errorMessage,
            placement: 'bottomLeft',
          });
        };
    }
  };

  const columns = [
    {
      title: 'Student ID',
      dataIndex: 'studentId',
      key: 'studentId',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Attendance',
      key: 'attendanceDate',
      dataIndex: 'attendanceDate',
      render: dates => (
        <React.Fragment>
          {Object.keys(dates).map(date => {
            const value = dates[date];
            const formattedDate = moment(date).format('Do MMM YYYY LT');

            const getColor = () => {
              switch(value) {
                case 'auth-absent': {
                  return 'orange';
                }

                case 'absent': {
                  return 'red';
                }

                default: {
                  return 'green';
                }
              }
            }

            return (
              <div>
                <Tag
                  color={getColor()}
                  key={date}
                >
                  {formattedDate}
                </Tag>
              </div>
            );
          })}
        </React.Fragment>
      ),
    },
    {
      title: 'Error',
      dataIndex: 'error',
      key: 'error',
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys) => {
      setSelectedRowKeys(selectedRowKeys);
    },
    getCheckboxProps: record => ({
      disabled: Boolean(record.error),
      name: record.studentId,
    }),
  };

  const renderButtons = (modifier) => {
    const onSubmit = async () => {
      if(!selectedRowKeys || !selectedRowKeys.length) {
        return notification.error({
          message: 'Error',
          description: 'Please select some rows',
          placement: 'bottomLeft',
        });
      }

      setSubmiting(true);
      
      const records = results.filter(result => {
        return !Boolean(result.error) && selectedRowKeys.includes(result.studentId)
      });

      const requestPayload = {
        "messageType": "attendance.import.submit-moodle-records",
        "payload": {
          "scheduleId": firstFormValues.scheduleId,
          "moodleRecords": records.map(record => ({ ...record, imported: true })),
        }
      }
  
      const response = await wsClient.request(requestPayload);

      if(response && response.payload === null) {
        setSubmiting(false);
        setResults([]);
        notification.success({
          message: 'Success',
          description: 'Successfully imported students',
          placement: 'bottomLeft',
        });
      }
    };

    const onCancel = () => {
      setResults([]);
    };

    return (
      <div className={cx('imports-content__buttons', `imports-content__buttons--${modifier}`)}>
        <Button
          type="primary"
          loading={submiting}
          onClick={onSubmit}
        >
          Submit selected
        </Button>

        <Button
          type="default"
          onClick={onCancel}
        >
          Cancel
        </Button>
      </div>
    )
  }

  return (
    <PageContainer>
      <PageContent className="imports-content">
        <PageContent.Main>
          <Title>
            Imports
          </Title>
  
          {results.length === 0 && (
            <ImportsForm
              initialValues={{
                type: 'Moodle',
                scheduleId: 'Choose Module',
              }}
              isSubmiting={submiting}
              onSubmit={handleSubmit}
            />
          )}

          {results.length > 0 && (
            <React.Fragment>
              <div className='imports-content__tag-keys'>
                <Tag color='green'>
                  Present
                </Tag>

                <Tag color='orange'>
                  Auth absent
                </Tag>

                <Tag color='red'>
                  Absent
                </Tag>
              </div>

              {renderButtons('top')}
              
              <Table
                dataSource={results}
                columns={columns}
                rowSelection={rowSelection}
                rowKey={row => row.studentId}
                pagination={false}
              />

              {renderButtons('bottom')}
            </React.Fragment>
          )}
        </PageContent.Main>
      </PageContent>
    </PageContainer>
  )
}

export default userIsAuthenticatedRedir(ImportsContainer);



// WEBPACK FOOTER //
// ./src/pages/imports/index.js